import { useState } from "react";
import MatterTypeStep from "./components/MatterTypeStep";
import { useNavigate, useSearchParams } from "react-router-dom";

const MatterIntakePage = () => {
  const [searchParams] = useSearchParams();
  const [step, setStep] = useState(parseInt(searchParams.get("step") || "0"));
  const navigate = useNavigate();

  const nextStep = () => {
    setStep((prev) => prev + 1);
  };
  const previousStep = () => {
    setStep((prev) => (prev > 0 ? prev - 1 : prev));
    navigate(-1);
    if (step <= 0) {
      navigate("/events");
    }
  };

  return (
    <>
      <div className="flex flex-col items-center justify-center min-h-screen">
        <div className="w-full max-w-screen-md">
          {step === 0 && <MatterTypeStep onBack={previousStep} />}
        </div>
      </div>
    </>
  );
};

export default MatterIntakePage;
